<template>
  <el-dialog :title="getTitle()" :visible.sync="show" width="80%" custom-class="form-select-dialog" append-to-body v-loading="loading">
    <div v-show="step === 1">
      <div class="app-toolbar2">
        <el-input size="small" placeholder="请输入名称或描述中的关键字" v-model="query.keyword" clearable style="width:320px">
          <el-button slot="append" size="small" icon="el-icon-search" @click="load(1)">查询</el-button>
        </el-input>
      </div>
      <el-table :data="dynamicForms" :stripe="true" size="mini" @current-change="select" @row-dblclick="selectAndNext" highlight-current-row ref="formTable">
        <el-table-column prop="dynamicFormId" label="ID" width="60"></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="desc" label="描述" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="tableName" label="表名" width="180"></el-table-column>
        <el-table-column prop="acType" label="访问控制类型" width="92">
          <template slot-scope="scope">
            <span v-if="scope.row.acType === acType.key" v-for="acType in acTypes" :key="acType.key">{{acType.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="140"></el-table-column>
        <el-table-column prop="updateTime" label="最后更新时间" width="140"></el-table-column>
      </el-table>
      <el-pagination v-show="query.total > 0" :page-size="query.limit" :pager-count="11" layout="total, prev, pager, next" :total="query.total" :background="true" @current-change="load" class="app-pagination"></el-pagination>
    </div>
    <div v-show="step === 2" style="text-align:center;padding-top:50px;">
      <el-radio-group v-model="dataType1" size="mini" @dblclick.native="gotoStep(true)">
        <el-radio-button label="OBJECT">单条数据</el-radio-button>
        <el-radio-button label="LIST">列表</el-radio-button>
        <el-radio-button label="PAGE">分页</el-radio-button>
        <el-radio-button label="FIELD">单个字段</el-radio-button>
      </el-radio-group>
    </div>
    <div v-show="step === 3">
      <el-table :data="columns" row-key="name" :stripe="true" size="mini" v-show="dataType !== 'FIELD' && dataType1 !== 'FIELD'">
        <el-table-column width="80">
          <template slot-scope="scope" slot="header">
            <el-checkbox ref="queryCheckboxHeader" @change="onQueryColumnHeaderCheckboxChange" label="查询" :indeterminate="isQueryColumnHeaderIndeterminate"></el-checkbox>
          </template>
          <template slot-scope="scope">
            <el-checkbox :ref="'queryCheckbox' + scope.$index" @change="onQueryColumnCheckboxChange(scope.$index)"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column width="80" v-if="dataType === 'LIST' || dataType === 'PAGE' || (!dataType && (dataType1 === 'LIST' || dataType1 === 'PAGE'))">
          <template slot-scope="scope" slot="header">
            <el-checkbox ref="displayCheckboxHeader" @change="onDisplayColumnHeaderCheckboxChange" label="展示" :indeterminate="isDisplayColumnHeaderIndeterminate"></el-checkbox>
          </template>
          <template slot-scope="scope">
            <el-checkbox :ref="'displayCheckbox' + scope.$index" @change="onDisplayColumnCheckboxChange(scope.$index)"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column prop="orderNo" label="顺序" width="140">
          <template slot-scope="scope">
            <el-input-number placeholder="请输入该列顺序" v-model="scope.row.orderNo" size="mini" :min="1" @change="reorderColumns('columns')"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="width" label="列宽" width="160">
          <template slot-scope="scope">
            <el-input placeholder="请输入该列所占宽度" v-model="scope.row.width" size="mini"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="newline" label="是否换行(默认换行)" width="145">
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row.newline" size="mini">
              <el-radio-button label="1">换行</el-radio-button>
              <el-radio-button label="0">不换行</el-radio-button>
            </el-radio-group>
          </template>
        </el-table-column>
        <el-table-column prop="displayName" label="展示名称">
          <template slot-scope="scope">
            <el-input placeholder="请输入展示名称" v-model="scope.row.displayName" size="mini"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="字段名" width="160"></el-table-column>
        <el-table-column prop="cmt" label="注释" :show-overflow-tooltip="true"></el-table-column>
      </el-table>
      <el-table :data="columns1" row-key="name" :stripe="true" size="mini" v-show="dataType === 'FIELD' || dataType1 === 'FIELD'">
        <el-table-column width="32">
          <template slot-scope="scope">
            <el-radio :label="scope.$index" v-model="selectedColumnRadio"></el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="orderNo" label="顺序" width="140">
          <template slot-scope="scope">
            <el-input-number placeholder="请输入该列顺序" v-model="scope.row.orderNo" size="mini" :min="1" @change="reorderColumns('columns1')"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="displayName" label="展示名称">
          <template slot-scope="scope">
            <el-input placeholder="请输入展示名称" v-model="scope.row.displayName" size="mini"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="字段名" width="160"></el-table-column>
        <el-table-column prop="cmt" label="注释"></el-table-column>
      </el-table>
    </div>
    <el-table v-show="step === 4" :data="conditions" :stripe="true" size="mini">
      <el-table-column label="数据库表中的列，多个列用英文逗号隔开">
        <template slot-scope="scope">
          <el-input size="mini" v-model="scope.row.column"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="运算符">
        <template slot-scope="scope">
          <el-select size="mini" v-model="scope.row.operator" style="width:100%;">
            <el-option v-for="o in operators" :key="o.value" :value="o.value" :label="o.label"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="页面控件ID或表达式">
        <template slot-scope="scope">
          <el-input size="mini" v-model="scope.row.relateComponentId"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="值处理函数">
        <template slot-scope="scope">
          <el-select size="mini" v-model="scope.row.valueProcessFn" clearable>
            <el-option v-for="valueProcess in valueProcesses" :key="valueProcess.name" :value="valueProcess.name" :label="valueProcess.desc"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="deleteCondition(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-form v-if="step === 5" :status-icon="true" label-width="140px" style="margin:20px auto;width:60%;">
      <el-form-item label="更新页面ID" v-if="device === 'MOBILE'">
        <el-input-number v-model="operations.updatePageId" placeholder="请输入更新页面ID" style="width:100%"></el-input-number>
      </el-form-item>
      <el-form-item label="更新对话框ID" v-if="device === 'PC'">
        <el-input v-model="operations.updateDialogId" placeholder="请输入更新对话框ID" style="width:100%"></el-input>
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="operations.useDefaultDeleteApi">使用默认的删除API</el-checkbox>
      </el-form-item>
      <el-form-item label="删除API">
        <el-input v-model="operations.deleteApi" placeholder="请输入删除API的地址" :disabled="operations.useDefaultDeleteApi"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="mini" type="primary" @click="addCondition" v-show="step === 4" style="float:left">添加条件</el-button>
      <el-button size="mini" @click="showTip = true" v-show="step === 4 || step === 5" style="float:left">查看说明</el-button>
      <el-button size="mini" @click="show = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="gotoStep(false)" v-show="step > 1">上一步</el-button>
      <el-button size="mini" type="primary" @click="gotoStep(true)" v-show="(configDataType && step < 2) || (configColumn1 && step < 3) || (configCondition && step < 4) || (configOperation && step < 5)" :disabled="!selected">下一步</el-button>
      <el-button size="mini" type="primary" @click="doSave" v-show="(step === 5) || (step === 4 && !configOperation) || (step === 3 && !configCondition && !configOperation) || (step === 2 && !configColumn1 && !configCondition && !configOperation) || (step === 1 && !configDataType && !configColumn1 && !configCondition && !configOperation)" :disabled="!selected">确 定</el-button>
    </div>

    <el-dialog title="说明" :visible.sync="showTip" width="80%" append-to-body>
      <div class="pc-select-dialog-tip" v-show="step === 4">
        <h3>什么是页面控件ID或表达式？</h3>
        <p>这里的“页面控件ID”是指，在当前页面上的某一个组件的ID。通过该ID，系统会自动找到该控件，并以其值作为查询条件的值。“表达式”为参数“param”或“account”的属性，写法例：“account.gridCode”</p>
      </div>
      <div class="pc-select-dialog-tip" v-show="step === 5">
        <h3>什么是更新页面ID？</h3>
        <p>如果当前被配置(数据源)的组件是一个列表，比如手机端的滚动分页列表，或者电脑端的分页列表，它们通常都会配备更新和删除的功能。而“更新页面”就是用于更新数据的页面，通过填写其ID，列表组件会自动添加更新按钮，点击该按钮就可以打开更新页面。</p>
        <h3>如果我不需要更新操作怎么办？</h3>
        <p>那就把“更新页面ID”空着，什么也不要填写。</p>
        <h3>什么是默认的删除API？</h3>
        <p>系统为动态表单提供了内置的数据维护接口，包括新增、更新、删除和查询。所以使用动态表单作为数据源的列表，可以使用动态表单的“默认删除API”，选中后，列表组件就会自动添加删除按钮了。</p>
        <h3>如果我有自定义的删除API，不想使用默认的删除API该怎么办？</h3>
        <p>那就不要选中“默认的删除API”，然后将你的自定义API填写在“删除API”中就可以了。</p>
        <p>但是请一定要记住，自定义删除接口必须遵循Restful规则：以DELETE作为请求方法；请求地址代表了被删除的数据。</p>
        <p>比如：http://www.demo.com/api/v1/dogs/，“www.demo.com”是API的域名，“/api”是API的标识，“/v1”是API的版本，“/dogs”代表了“狗”这种资源。</p>
        <p>系统按照Restful规则，在地址后面拼接上被用户删除的那条狗的ID，形成如下地址“http://www.demo.com/api/v1/dogs/1”，并以DELETE方法请求该地址。</p>
        <h3>如果我不需要删除操作怎么办？</h3>
        <p>那就不要选中“默认的删除API”，也不要填写“删除API”。</p>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { acTypes } from '@/config'
import { getDevice } from '../util.js'

export default {
  name: 'form-select-dialog',
  props: {
    endpoint: { type: String, required: true },
    uiId: { type: Number, required: true },
    dataType: { type: String, required: false },
    configColumn: { type: Boolean, required: false, default: false },
    configCondition: { type: Boolean, required: false, default: false },
    configOperation: { type: Boolean, required: false, default: false },
    excludeNoneTable: { type: Boolean, required: false, default: true }
  },
  data () {
    return {
      acTypes: acTypes,
      device: '',
      dynamicForm: {},
      show: false,
      step: 0,
      loading: false,
      query: {
        page: 1,
        limit: 10,
        total: 0,
        keyword: ''
      },
      dynamicForms: [],
      selected: null,
      dynamicFormIdOfColumns: null,
      isQueryColumnHeaderIndeterminate: false,
      isDisplayColumnHeaderIndeterminate: false,
      columns: null,
      selectedColumnRadio: 0,
      columns1: null,
      conditions: null,
      operations: null,
      configDataType: false,
      dataType1: null,
      operators: [
        { value: '=', label: '等于', type: 'single' },
        { value: 'LIKE', label: '模糊查询', type: 'single' },
        { value: '>', label: '大于', type: 'single' },
        { value: '<', label: '小于', type: 'single' },
        { value: '>=', label: '大于等于', type: 'single' },
        { value: '<=', label: '小于等于', type: 'single' },
        { value: '<>', label: '不等于', type: 'single' },
        { value: 'IN', label: 'IN', type: 'range' },
        { value: 'NOT IN', label: 'NOT IN', type: 'range' },
        { value: 'IS NOT NULL', label: '不为空', type: 'none' },
        { value: 'IS NULL', label: '为空', type: 'none' }
      ],
      valueProcesses: [],
      showTip: false
    }
  },
  computed: {
    configColumn1: function () {
      return this.configColumn || this.dataType === 'FIELD' || (!this.dataType && this.dataType1 === 'FIELD')
    }
  },
  created () {
    this.device = getDevice(this.endpoint)
  },
  watch: {
    step (val) {
      let me = this
      if (val === 3) {
        if (me.dynamicFormIdOfColumns === me.selected.dynamicFormId) {
          return
        }

        me.loading = true
        me.$http.request({
          method: 'get',
          url: `/api/cgRdbDataSources/0/metadata?tableName=${me.selected.tableName}`
        }).then((res) => {
          me.loading = false
          if (!res.data.data || res.data.data.length == 0) {
            return
          }

          let columns = res.data.data[0].metaColumns || []
          for (let column of columns) {
            column.displayName = column.displayName || column.cmt
          }

          let arr = []
          let currentOrderNo = 1
          let selectedColumns = me.dynamicForm.columns || []
          for (let selectedColumn of selectedColumns) {
            for (let column of columns) {
              if (selectedColumn.name === column.name) {
                column.displayName = selectedColumn.displayName
                column.width = selectedColumn.width
                column.newline = selectedColumn.newline
                column.orderNo = currentOrderNo++
                arr.push(column)
                break
              }
            }
          }

          for (let column of columns) {
            if (column.orderNo === undefined) {
              column.orderNo = currentOrderNo++
              arr.push(column)
            }
          }
          columns = arr

          me.dynamicFormIdOfColumns = me.selected.dynamicFormId
          me.columns = columns

          let columns1 = JSON.parse(JSON.stringify(columns))
          me.columns1 = columns1

          if (me.selected.dynamicFormId === me.dynamicForm.id) {
            let selectedColumns = me.dynamicForm.columns || []
            me.dynamicForm.columns = null

            if (selectedColumns.length) {
              me.$nextTick(() => {
                if (selectedColumns.length === 1 && selectedColumns[0].radio) {
                  for (let i = 0; i < columns1.length; i++) {
                    if (columns1[i].name === selectedColumns[0].name) {
                      me.selectedColumnRadio = i
                      break
                    }
                  }
                } else {
                  for (let i = 0; i < columns.length; i++) {
                    let column = columns[i]
                    for (let j = 0; j < selectedColumns.length; j++) {
                      if (column.name === selectedColumns[j].name) {
                        me.$refs['queryCheckbox' + i].model = true

                        let displayCheckbox = me.$refs['displayCheckbox' + i]
                        if (selectedColumns[j].display && displayCheckbox) {
                          displayCheckbox.model = true
                        }
                        break
                      }
                    }
                  }
                  me.changeColumnHeaderIndeterminate()
                }
              })
            }
          }
        }).catch(() => {
          me.loading = false
        })
      } else if (val === 4) {
        if (me.conditions) {
          return
        }
        let conditions
        if (me.selected.dynamicFormId === me.dynamicForm.id && me.dynamicForm.conditions) {
          conditions = me.dynamicForm.conditions
          me.dynamicForm.conditions = null
        } else {
          conditions = [{}]
        }
        me.conditions = conditions

        if (!me.valueProcesses || !me.valueProcesses.length) {
          me.$http.request({
            method: 'get',
            url: '/api/cgValueProcesses'
          }).then((res) => {
            me.valueProcesses = res.data.data
          })
        }
      } else if (val === 5) {
        if (me.operations) {
          return
        }
        let operations = me.dynamicForm.operations
        if (me.selected.dynamicFormId === me.dynamicForm.id && operations) {
          let useDefaultDeleteApi = operations.deleteApi === 'dynamicFormDefaultApi'
          me.operations = {
            updatePageId: operations.updatePageId,
            updateDialogId: operations.updateDialogId,
            useDefaultDeleteApi: useDefaultDeleteApi,
            deleteApi: useDefaultDeleteApi ? null : operations.deleteApi
          }
          me.dynamicForm.operations = null
        } else {
          me.operations = { useDefaultDeleteApi: false }
        }
      }
    }
  },
  methods: {
    getTitle () {
      if (this.step === 1) {
        return '选择动态表单'
      }
      if (this.step === 2) {
        return '配置数据类型'
      }
      if (this.step === 3) {
        return '选择要展示的列'
      }
      if (this.step === 4) {
        return '配置查询条件'
      }
      if (this.step === 5) {
        return '配置更新与删除'
      }
    },
    open (value) {
      this.dynamicForm = value ? JSON.parse(value) : {}
      this.query.keyword = ''
      this.dynamicFormIdOfColumns = null
      this.isQueryColumnHeaderIndeterminate = false
      this.isDisplayColumnHeaderIndeterminate = false
      this.columns = null
      this.selectedColumnRadio = 0
      this.columns1 = null
      this.conditions = null
      this.operations = null
      if (this.dataType) {
        this.configDataType = false
        this.dataType1 = null
      } else {
        this.configDataType = true
        this.dataType1 = this.dynamicForm.dataType || 'OBJECT'
      }
      this.load(1, this.dynamicForm.id)
      this.step = 1
      this.show = true
    },
    load (page, dynamicFormId) {
      let url = `/api/cgDynamicForms?keyword=${this.query.keyword}&excludeNoneTable=${this.excludeNoneTable ? 'YES' : 'NO'}&page=${page}&limit=${this.query.limit}`
      if (dynamicFormId) {
        url = `${url}&dynamicFormId=${dynamicFormId}`
      }
      if (this.uiId) {
        url = `${url}&uiId=${this.uiId}`
      }

      this.loading = true
      this.$http.request({
        method: 'get',
        url: url
      }).then((res) => {
        let pageData = res.data.data
        this.dynamicForms = pageData.data
        this.query.page = pageData.page
        this.query.total = pageData.total
        this.loading = false

        if (dynamicFormId && this.dynamicForms.length) {
          this.$refs.formTable.setCurrentRow(this.dynamicForms[0])
        } else {
          this.$refs.formTable.setCurrentRow()
        }
      }).catch(() => {
        this.loading = false
      })
    },
    select (row) {
      this.selected = row || null
    },
    selectAndNext (row) {
      this.selected = row || null
      if (this.selected) {
        if (!this.configDataType && !this.configColumn1 && !this.configCondition && !this.configOperation) {
          this.doSave()
        } else {
          this.gotoStep(true)
        }
      }
    },
    gotoStep (forward) {
      let result = this.step
      let step = this.step
      if (forward) {
        if (step === 1) {
          if (this.configDataType) {
            result = 2
          } else if (this.configColumn1) {
            result = 3
          } else if (this.configCondition) {
            result = 4
          } else if (this.configOperation) {
            result = 5
          }
        } else if (step === 2) {
          if (this.configColumn1) {
            result = 3
          } else if (this.configCondition) {
            result = 4
          } else if (this.configOperation) {
            result = 5
          }
        } else if (step === 3) {
          if (this.configCondition) {
            result = 4
          } else if (this.configOperation) {
            result = 5
          }
        } else if (step === 4) {
          if (this.configOperation) {
            result = 5
          }
        }
      } else {
        if (step === 5) {
          if (this.configCondition) {
            result = 4
          } else if (this.configColumn1) {
            result = 3
          } else if (this.configDataType) {
            result = 2
          } else {
            result = 1
          }
        } else if (step === 4) {
          if (this.configColumn1) {
            result = 3
          } else if (this.configDataType) {
            result = 2
          } else {
            result = 1
          }
        } else if (step === 3) {
          if (this.configDataType) {
            result = 2
          } else {
            result = 1
          }
        } else if (step === 2) {
          result = 1
        }
      }
      this.step = result
    },
    addCondition () {
      this.conditions.push({})
    },
    deleteCondition (index) {
      this.conditions.splice(index, 1)
    },
    reorderColumns (type) {
      this[type] = this[type].sort((c1, c2) => {
        if (c1.orderNo === undefined && c2.orderNo === undefined) {
          return 0
        }
        if (c1.orderNo === undefined && c2.orderNo !== undefined) {
          return 1
        }
        if (c1.orderNo !== undefined && c2.orderNo === undefined) {
          return -1
        }
        return c1.orderNo - c2.orderNo
      })
    },
    onQueryColumnHeaderCheckboxChange (checked) {
      let len = this.columns.length
      if (this.isQueryColumnHeaderIndeterminate) {
        this.isQueryColumnHeaderIndeterminate = false
        for (let i = 0; i < len; i++) {
          this.$refs['queryCheckbox' + i].model = true
        }
        this.$refs.queryCheckboxHeader.model = true
      } else {
        if (checked) {
          for (let i = 0; i < len; i++) {
            this.$refs['queryCheckbox' + i].model = true
          }
        } else {
          this.isDisplayColumnHeaderIndeterminate = false
          for (let i = 0; i < len; i++) {
            this.$refs['queryCheckbox' + i].model = false

            let displayCheckbox = this.$refs['displayCheckbox' + i]
            if (displayCheckbox) {
              displayCheckbox.model = false
            }
          }

          let displayCheckboxHeader = this.$refs.displayCheckboxHeader
          if (displayCheckboxHeader) {
            displayCheckboxHeader.model = false
          }
        }
      }
    },
    onDisplayColumnHeaderCheckboxChange (checked) {
      let len = this.columns.length
      if (this.isDisplayColumnHeaderIndeterminate) {
        this.isQueryColumnHeaderIndeterminate = false
        this.isDisplayColumnHeaderIndeterminate = false
        for (let i = 0; i < len; i++) {
          this.$refs['displayCheckbox' + i].model = true
          this.$refs['queryCheckbox' + i].model = true
        }
        this.$refs.queryCheckboxHeader.model = true
        this.$refs.displayCheckboxHeader.model = true
      } else {
        if (checked) {
          this.isQueryColumnHeaderIndeterminate = false
          this.isDisplayColumnHeaderIndeterminate = false
          for (let i = 0; i < len; i++) {
            this.$refs['displayCheckbox' + i].model = true
            this.$refs['queryCheckbox' + i].model = true
          }
          this.$refs.queryCheckboxHeader.model = true
          this.$refs.displayCheckboxHeader.model = true
        } else {
          this.isDisplayColumnHeaderIndeterminate = false
          for (let i = 0; i < len; i++) {
            this.$refs['displayCheckbox' + i].model = false
          }
          this.$refs.displayCheckboxHeader.model = false
        }
      }
    },
    onQueryColumnCheckboxChange (index) {
      if (!this.$refs['queryCheckbox' + index].isChecked) {
        let displayCheckbox = this.$refs['displayCheckbox' + index]
        if (displayCheckbox) {
          displayCheckbox.model = false
        }
      }
      this.changeColumnHeaderIndeterminate()
    },
    onDisplayColumnCheckboxChange (index) {
      if (this.$refs['displayCheckbox' + index].isChecked) {
        this.$refs['queryCheckbox' + index].model = true
      }
      this.changeColumnHeaderIndeterminate()
    },
    changeColumnHeaderIndeterminate () {
      let j = 0
      let k = 0
      let len = this.columns.length
      for (let i = 0; i < len; i++) {
        if (this.$refs['queryCheckbox' + i].isChecked) {
          j++
        }
        let displayCheckbox = this.$refs['displayCheckbox' + i]
        if (displayCheckbox && displayCheckbox.isChecked) {
          k++
        }
      }
      if (j > 0 && j < len) {
        this.isQueryColumnHeaderIndeterminate = true
      } else {
        this.isQueryColumnHeaderIndeterminate = false
        this.$refs.queryCheckboxHeader.model = j > 0
      }

      let displayCheckboxHeader = this.$refs.displayCheckboxHeader
      if (displayCheckboxHeader) {
        if (k > 0 && k < len) {
          this.isDisplayColumnHeaderIndeterminate = true
        } else {
          this.isDisplayColumnHeaderIndeterminate = false
          displayCheckboxHeader.model = k > 0
        }
      }
    },
    getSelectedColumn () {
      let queryColumns = []
      if (this.dataType === 'FIELD' || this.dataType1 === 'FIELD') {
        let column = this.columns1[this.selectedColumnRadio]
        queryColumns.push({
          name: column.name,
          displayName: column.displayName || column.cmt,
          radio: true
        })
      } else {
        let len = this.columns.length
        for (let i = 0; i < len; i++) {
          let selected
          let column = this.columns[i]
          if (this.$refs['queryCheckbox' + i].isChecked) {
            selected = {
              name: column.name,
              displayName: column.displayName ? column.displayName : column.cmt,
              width: column.width,
              newline: column.newline,
              orderNo: column.orderNo
            }
            let displayCheckbox = this.$refs['displayCheckbox' + i]
            if (displayCheckbox && displayCheckbox.isChecked) {
              selected.display = true
            }
          }
          if (selected) {
            queryColumns.push(selected)
          }
        }

        queryColumns = queryColumns.sort((c1, c2) => {
          return c1.orderNo - c2.orderNo
        })

        for (let column of queryColumns) {
          delete column.orderNo
        }
      }

      return queryColumns
    },
    doSave () {
      let columns
      if (this.configColumn1) {
        let selected = this.getSelectedColumn()
        if (!selected.length) {
          alert('请选择要展示的列')
          return
        }
        columns = selected
      }

      let conditions = []
      if (this.configCondition) {
        for (let condition of this.conditions) {
          let hasOwnProperty = false
          for (let f in condition) {
            if (condition.hasOwnProperty(f)) {
              hasOwnProperty = true
              break
            }
          }

          if (hasOwnProperty) {
            conditions.push(condition)
          }
        }
      }

      let data = { type: 'dynamicForm', id: this.selected.dynamicFormId, name: this.selected.name }
      if (this.dataType !== 'none') {
        data.dataType = this.dataType || this.dataType1
      }
      if (columns) {
        data.columns = columns
      }
      if (conditions.length) {
        data.conditions = conditions
      }

      if (this.operations) {
        let updatePageId = this.operations.updatePageId
        let updateDialogId = this.operations.updateDialogId
        let deleteApi = this.operations.useDefaultDeleteApi ? 'dynamicFormDefaultApi' : this.operations.deleteApi
        if (updatePageId || deleteApi || updateDialogId) {
          data.operations = {
            idColumnName: this.selected.idColumnName,
            updatePageId: updatePageId,
            updateDialogId: updateDialogId,
            deleteApi: deleteApi
          }
        }
      }

      this.$emit('save', data)
      this.show = false
    }
  }
}
</script>

<style>
.form-select-dialog .el-dialog__body{padding:0;margin-top:10px;border-top:1px solid #ebeef5;}
</style>
